import 'sober';

import './script';
import { listen } from './listeners';

listen();
